// src/components/global/ErrorFallback.jsx
import React from "react";
import styled from "styled-components";
import Heading from "./Heading";
import Button from "./ButtonBackError";
import { CssBaseline, Stack } from "@mui/material";

const StyledErrorFallback = styled.main`
  height: 100vh;
  background-color: var(--color-grey-50, #f9fafb);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4.8rem;
`;

const Box = styled.div`
  background-color: var(--color-grey-0, #ffffff);
  border: 1px solid var(--color-grey-100, #e5e7eb);
  border-radius: var(--border-radius-md, 8px);

  padding: 4.8rem;
  flex: 0 1 72rem;
  max-width: 90%;
  text-align: center;

  & h1 {
    margin-bottom: 1.6rem;
  }

  & p {
    font-family: "Sono", sans-serif;
    margin-bottom: 3.2rem;
    color: var(--color-grey-500, #6b7280);
    word-break: break-word;
  }
`;

function ErrorFallback({ error, resetErrorBoundary }) {
  const isArabic = (localStorage.getItem("i18nextLng") || "ar").startsWith("ar");

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <>
      <CssBaseline />
      <StyledErrorFallback dir={isArabic ? "rtl" : "ltr"}>
        <Box>
          <Heading as="h1">
            {isArabic ? "حدث خطأ غير متوقع 🧐" : "Something went wrong 🧐"}
          </Heading>
          <p>{error?.message || (isArabic ? "يرجى إعادة المحاولة" : "Please try again")}</p>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            useFlexGap
          >
            <Button size="large" variation="primary" onClick={resetErrorBoundary}>
              {isArabic ? "إعادة المحاولة" : "Try again"}
            </Button>
            <Button size="large" variation="secondary" onClick={handleGoHome}>
              {isArabic ? "العودة للرئيسية" : "Go to Home"}
            </Button>
          </Stack>
        </Box>
      </StyledErrorFallback>
    </>
  );
}

export default ErrorFallback;
